import React, { PropsWithChildren } from 'react';
import cn from "classnames";
import styles from './panel.module.scss';

interface PanelProps extends PropsWithChildren {
    view?: "primary" | "secondary" | "outline"
    className?: string;
    id?: string;
    onClick?: (e: any) => void,
}

export const Panel: React.FC<PanelProps> = React.memo(({
                                                           children,
                                                           id,
                                                           view = "secondary",
                                                           className,
                                                           onClick
                                                       }) => {
    let backgroundStyle;

    switch (view) {
        case 'primary': {
            backgroundStyle = styles.primaryBackground;
            break;
        }

        case 'secondary': {
            backgroundStyle = styles.secondaryBackground;
            break;
        }

        case 'outline': {
            backgroundStyle = styles.outlineBackground;
            break;
        }
    }


    return <div
        id={id}
        onClick={onClick}
        className={cn(styles.panel, className, backgroundStyle)}>
        {children}
    </div>
});
